import React from 'react';
import {
   ActivityIndicator,
   Image,
   SafeAreaView,
   Text,
   TextInput,
   TouchableOpacity,
   View,
   KeyboardAvoidingView,
   Platform,
} from 'react-native';
import {
   FONT_FAMILY_BOLD,
   FONT_FAMILY_REGULAR,
   SUBMIT_FEEDBACK,
   primaryColor400,
   white,
   submitFeedbackParams,
   isWeb,
   ActivityLoaderColor,
   WHITE_ICON_HOVER_TINT_COLOR,
   alertHandler as alertHandlers,
} from '../../utils/utils';
import {getNavBarHeight} from '../../utils/utils';
import {useState} from 'react';
import {
   apiPostRequest,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import logger from '../../utils/logger';
import {useDispatch, useSelector} from 'react-redux';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {setResponseAlertData} from '../../redux/slices/ResponseAlertSlice';

const FeedBackView = props => {
   const dispatch = useDispatch();
   const [feedback, setFeedback] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const [layout, setLayout] = useState({});
   const authData = useSelector(selectAuthData);
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const [isHoverBackIcon, setHoverBackIcon] = useState(false);
   const [isHoverSubmmit, setHoverSubmmit] = useState(false);

   function callFeedbackApi(params) {
      if (!feedback.trim()) {
         alertHandler('Please enter feedback.');
         return;
      }
      setIsLoading(true);
      const reqParms = submitFeedbackParams(
         props.courseData,
         authData,
         feedback,
      );
      apiPostRequest({
         url: SUBMIT_FEEDBACK,
         parms: reqParms,
      })
         .then(res => {
            setIsLoading(false);
            props.onClose();
            if (res && res.StatusResult) {
               logger('Success Response:: ' + res);
            } else if (typeof res === 'string') {
               logger('Exception Response:: ' + JSON.stringify(res));
               if (isWeb) {
                  showTokenExpireAlertWeb(res);
               } else {
                  alert(res);
               }
            } else {
               logger('Error Response:: ' + JSON.stringify(res));
            }
         })
         .catch(error => {
            logger('error::', error);
         });
   }
   function alertHandler(message, callbackType = 'NO_BACK') {
      if (isWeb) {
         alertHandlers(dispatch, setResponseAlertData, message, callbackType);
      } else {
         alert(message);
      }
   }
   const isLandScapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   return (
      <SafeAreaView
         style={{
            width: '100%',
            height: '100%',
            backgroundColor: '#000',
            paddingVertical: 16,
            paddingHorizontal: 30,
         }}>
         <KeyboardAvoidingView
            style={{
               flex: 1,
               ...Platform.select({
                  web: {
                     flex: 1,
                     marginTop: '1%',
                     height:
                        !isLandscapeMode && !isLandScapeSmallWebView
                           ? '90vw'
                           : '90vh',
                  },
               }),
            }}
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
            <View
               style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  height:
                     Platform.OS === 'windows'
                        ? 50
                        : Platform.OS === 'macos'
                        ? 20
                        : getNavBarHeight(),
                  ...Platform.select({
                     web: {
                        marginBottom: 2,
                        marginLeft: 1,
                        marginTop: 2,
                     },
                  }),
               }}>
               <TouchableOpacity
                  onMouseEnter={() => setHoverBackIcon(true)}
                  onMouseLeave={() => setHoverBackIcon(false)}
                  style={{/* padding: 10, */ marginTop: 0}}
                  onPress={() => {
                     props.onClose();
                  }}>
                  <Image
                     source={require('../../assets/back_arrow.png')}
                     style={{
                        width: 16,
                        height: 16,
                        tintColor: isHoverBackIcon
                           ? WHITE_ICON_HOVER_TINT_COLOR
                           : white,
                     }}
                  />
               </TouchableOpacity>
               <Text
                  style={{
                     fontSize: 16,
                     fontWeight: '600',
                     fontFamily: FONT_FAMILY_REGULAR,
                     color: 'white',
                     marginStart: 16,
                     marginTop: 0,
                  }}>
                  {'Slide Feedback'}
               </Text>
            </View>
            <View
               style={{
                  flex: 1,
                  backgroundColor: '#454545',
                  borderRadius: 6,
                  ...Platform.select({
                     web: {
                        flex: null,
                        height:
                           !isLandscapeMode || isLandScapeSmallWebView
                              ? '70%'
                              : '80%',
                        marginTop: isLandscapeMode ? '2%' : '4%',
                     },
                     macos: {
                        marginTop: 30,
                     },
                  }),
               }}>
               <TextInput
                  style={[
                     {
                        padding: 16,
                        color: white,
                        alignItems: 'flex-start',
                        backgroundColor:
                           Platform.OS === 'windows' ? '#454545' : null,
                        height: '100%',
                        paddingTop: Platform.OS === 'macos' ? 40 : null,
                     },
                  ]}
                  multiline={true}
                  placeholder="Enter Slide Feedback"
                  placeholderTextColor={white}
                  color={white}
                  maxLength={500}
                  underlineColorAndroid={'rgba(0,0,0,0)'}
                  onChangeText={feedback => setFeedback(feedback)}
                  returnKeyType="done"
                  blurOnSubmit={true}
                  textAlignVertical="top"
               />
            </View>
            <View
               style={{
                  flex: 0,
                  flexDirection: 'row',
                  paddingVertical: 10,
                  ...Platform.select({
                     web: {
                        flex: null,
                     },
                  }),
               }}>
               <Text
                  style={{
                     fontSize: 10,
                     fontWeight: '400',
                     fontFamily: FONT_FAMILY_REGULAR,
                     color: 'white',
                     marginTop: 0,
                     flex: 1,
                     ...Platform.select({
                        web: {
                           fontSize: isLandscapeMode ? 15 : 10,
                        },
                     }),
                  }}>
                  {' Descriptions 500 Character Maximum'}
               </Text>
               <TouchableOpacity
                  onMouseEnter={() => setHoverSubmmit(true)}
                  onMouseLeave={() => setHoverSubmmit(false)}
                  style={{
                     paddingHorizontal: 16,
                     paddingVertical: 10,
                     backgroundColor: isHoverSubmmit
                        ? WHITE_ICON_HOVER_TINT_COLOR
                        : '#FFFFFF',
                     borderRadius: 8,
                     justifyContent: 'center',
                     alignItems: 'center',
                     ...Platform.select({
                        web: {
                           paddingHorizontal: 20,
                           paddingVertical: 15,
                        },
                     }),
                  }}
                  onPress={() => {
                     callFeedbackApi();
                  }}>
                  <View
                     style={{
                        flexDirection: 'row-reverse',
                        alignItems: 'center',
                     }}>
                     <Image
                        source={require('../../assets/single_tick.png')}
                        style={{
                           width: 12,
                           height: 12,
                           marginLeft: 8,
                           tintColor: '#003DA5',
                        }}
                     />
                     <Text
                        style={{
                           color: '#003DA5',
                           fontFamily: FONT_FAMILY_BOLD,
                           fontSize: 14,
                           fontWeight: '700',
                           marginLeft: 0,
                        }}>
                        {'Submit'}
                     </Text>
                  </View>
               </TouchableOpacity>
            </View>
            {isLoading && (
               <View
                  style={{
                     width: '100%',
                     height: '100%',
                     justifyContent: 'center',
                     alignItems: 'center',
                     position: 'absolute',
                  }}>
                  <ActivityIndicator size="large" color={ActivityLoaderColor} />
               </View>
            )}
         </KeyboardAvoidingView>
      </SafeAreaView>
   );
};

export default FeedBackView;
